import { useCallback, useRef } from "react";

import { MaskedInput } from "~/components/TextInput";
import { setCorporalEvaluationImageIndex } from "~/modules/corporalEvaluation/services";
import { evaluationAtom } from "~/modules/evalutation/data";
import { patchEvaluationAtom } from "~/modules/evalutation/services";

import { Mean } from "./Mean";

export const AxillaInput: React.FC = () => {
	const axillaRef = useRef(evaluationAtom.get()?.axilla ?? []);

	const handleUpdateField = useCallback((index: number, value: number) => {
		const newArr = [...axillaRef.current];
		newArr[index] = +value;
		axillaRef.current = newArr;
		patchEvaluationAtom({ axilla: newArr });
	}, []);

	const handleFocus = useCallback(() => {
		setCorporalEvaluationImageIndex(6);
	}, []);

	return (
		<>
			<div className="whitespace-nowrap font-bold xl:font-normal">
				Axila Média (mm) &nbsp;
			</div>
			{axillaRef.current.map((val, index) => (
				<div key={`axilla-${index}`}>
					<p className="block xl:hidden mb-2">Medida {index + 1}</p>
					<MaskedInput
						value={val}
						placeholder="0"
						mask="float"
						inputMode="decimal"
						onFocus={handleFocus}
						onChange={(v) => handleUpdateField(index, v)}
					/>
				</div>
			))}
			<div>
				<p className="block xl:hidden mb-2">Média</p>
				<Mean field="axilla" />
			</div>
		</>
	);
};
